// Name validator: only alphabets + spaces, min 2 chars
const nameRegex: RegExp = /^[A-Za-z\s]{2,}$/;
function validateName(name: string): boolean {
  return nameRegex.test(name);
}

// Email validator: stricter pattern
const emailRegex: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
function validateEmail(email: string): boolean {
  return emailRegex.test(email);
}

// Phone validator: only digits (allow 7–15 digits for flexibility)
function validatePhone(phone: string): boolean {
  const cleaned = phone.replace(/\D/g, ""); 
  const phoneRegex: RegExp = /^[0-9]{7,15}$/;
  return phoneRegex.test(cleaned);
}

// Date of Birth validator (manual entry allowed 01–31 + month + year check)
// ⚠️ Assumes input format: "YYYY-MM-DD"
function validateDOB(date: string): boolean {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return false;

  const [year, month, day] = date.split("-").map(Number);

  // check valid month
  if (month < 1 || month > 12) return false;

  // check valid day range
if (day < 1 || day > 31) return false;


  // check if date actually exists
  const d = new Date(year, month - 1, day);
  return (
    d.getFullYear() === year &&
    d.getMonth() === month - 1 &&
    d.getDate() === day
  );
}

// File validator: allow only .txt, .pdf, .png, .jpg, .jpeg
function validateFile(file: File): boolean {
  const allowedTypes = [
    "application/pdf",
    "text/plain",
    "image/png",
    "image/jpeg",
  ];
  return allowedTypes.includes(file.type);
}

export {
  validateName,
  validateEmail,
  validatePhone,
  validateDOB,
  // validateCurrentGrade,
  validateFile,
};
